/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { IconImg, LogoImg, LinkContainer } from './styled';
import icon from './images/arrow-left.svg';

const BackButton = ({ returnUrl, imageUrl, ...props }) => (
    <LinkContainer {...props} href={returnUrl} rel="nofollow">
        <IconImg src={icon} />
        <LogoImg src={imageUrl} />
    </LinkContainer>
);

BackButton.propTypes = {
    returnUrl: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
};

export default BackButton;
